import { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { useSelectedEnvironmentKey } from '@gonfalon/app-context/useSelectedEnvironmentKey';
import { useProjectKey } from '@gonfalon/router/useProjectKey';

import { fetchFlagIfNeeded } from '#actions/flags';
import { flagByKeyForProjectSelector, flagRequestByKeyForProjectSelector } from '#reducers/flags';
import { currentProjectKeySelector } from '#reducers/projects';
import type { GlobalDispatch, GlobalState } from '#reducers/state';
import type { Flag } from '#utils/flags/records/Flag';
import { ready } from '#utils/reduxUtils';

export type FlagDisplayForInstructionsContainerProp = {
  isReady: boolean;
  flagKey: string;
  flag?: Flag;
  fetchFlag(flagKey: string, projKey: string, envKey: string): void;
};

export function FlagDisplayForInstructions({
  isReady,
  flagKey,
  flag,
  fetchFlag,
}: FlagDisplayForInstructionsContainerProp) {
  const projKey = useProjectKey();
  const envKey = useSelectedEnvironmentKey();

  useEffect(() => {
    if (!isReady) {
      fetchFlag(projKey, flagKey, envKey);
    }
  }, []);

  return flag ? <Link to={flag.siteLink(envKey)}>{flag.name}</Link> : <code>{flagKey}</code>;
}

type FlagDisplayForInstructionsContainerOwnProps = {
  flagKey: string;
  projKey?: string;
};

const mapStateToProps = (
  state: GlobalState,
  { flagKey, projKey = currentProjectKeySelector(state) }: FlagDisplayForInstructionsContainerOwnProps,
) => {
  const request = flagRequestByKeyForProjectSelector(state, { flagKey, projKey });
  /* eslint-disable @typescript-eslint/no-non-null-assertion */
  const flag = flagByKeyForProjectSelector(state, {
    flagKey,
    projKey,
  }).entity!; /* eslint-enable @typescript-eslint/no-non-null-assertion */
  const isReady = ready(request);
  return {
    isReady,
    flag,
  };
};

const mapDispatchToProps = (dispatch: GlobalDispatch) => ({
  fetchFlag: (flagKey: string, projKey: string, envKey: string) =>
    dispatch(fetchFlagIfNeeded(projKey, flagKey, envKey)),
});

export const ConnectedFlagDisplayForInstructions = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FlagDisplayForInstructions);
